// @generated by protoc-gen-es v2.16.0 with parameter "target=js+dts"
// @generated from file sup/sup.proto (package sup, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file sup/sup.proto.
 */
export const file_sup_sup = /*@__PURE__*/
  fileDesc("Cg1zdXAvc3VwLnByb3RvEgNzdXAiGgoKU3VwUmVxdWVzdBIMCgRuYW1lGAEgASgJIh4KC1N1cFJlc3BvbnNlEg8KB21lc3NhZ2UYASABKAkyOwoKU3VwU2VydmljZRItCgZTYXlTdXASDy5zdXAuU3VwUmVxdWVzdBoQLnN1cC5TdXBSZXNwb25zZSIAQixaKmdpdGh1Yi5jb20vbWF5YmVjYWtlL3N0YWNrcy9nZW4vZ28vc3VwO3N1cGIGcHJvdG8z");

/**
 * Describes the message sup.SupRequest.
 * Use `create(SupRequestSchema)` to create a new message.
 */
export const SupRequestSchema = /*@__PURE__*/
  messageDesc(file_sup_sup, 0);

/**
 * Describes the message sup.SupResponse.
 * Use `create(SupResponseSchema)` to create a new message.
 */
export const SupResponseSchema = /*@__PURE__*/
  messageDesc(file_sup_sup, 1);

/**
 * @generated from service sup.SupService
 */
export const SupService = /*@__PURE__*/
  serviceDesc(file_sup_sup, 0);

